import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore, useUIStore } from '../../store/authStore';
import { Menu, LogOut, User, Globe, Type } from 'lucide-react';
import { cn } from '../../lib/utils';

const fontSizes = [
  { key: 'small', label: 'A', className: 'text-xs' },
  { key: 'medium', label: 'A', className: 'text-sm' },
  { key: 'large', label: 'A', className: 'text-base' },
];

export default function Navbar({ onMenuClick }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const { fontSize, setFontSize } = useUIStore();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'zh-TW' ? 'en' : 'zh-TW';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 h-16 bg-tpc-blue shadow-lg z-50">
      <div className="h-full px-4 flex items-center justify-between">
        {/* Left side */}
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
          >
            <Menu className="w-6 h-6" />
          </button>

          <div className="text-white">
            <h1 className="text-lg font-semibold hidden sm:block">
              {t('app.name')}
            </h1>
            <h1 className="text-lg font-semibold sm:hidden">
              {t('app.shortName')}
            </h1>
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-1 sm:gap-2">
          {/* Font size toggle */}
          <div className="flex items-center bg-white/10 rounded-lg p-0.5" title={t('settings.fontSize', '字體大小')}>
            {fontSizes.map((size) => (
              <button
                key={size.key}
                onClick={() => setFontSize(size.key)}
                className={cn(
                  'px-2 py-1 rounded transition-colors',
                  size.className,
                  fontSize === size.key
                    ? 'bg-white text-tpc-blue font-bold'
                    : 'text-white/80 hover:text-white'
                )}
              >
                {size.label}
              </button>
            ))}
          </div>

          {/* Language toggle */}
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-1 px-3 py-2 text-white/90 hover:text-white hover:bg-white/10 rounded-lg transition-colors text-sm"
          >
            <Globe className="w-4 h-4" />
            <span className="hidden sm:inline">{t('language.switch')}</span>
          </button>

          {/* User info */}
          <button
            onClick={() => navigate('/profile')}
            className="flex items-center gap-2 px-3 py-2 text-white/90 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
          >
            <User className="w-4 h-4" />
            <span className="hidden sm:inline text-sm">
              {user?.fullName}
            </span>
          </button>

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-1 px-3 py-2 text-white/90 hover:text-white hover:bg-white/10 rounded-lg transition-colors text-sm"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">{t('nav.logout')}</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
